import classnames from 'classnames';
import React from 'react';
import './Modal.scss';

const Modal = ({ acceptText, cancelText, children, className, onClose, open, scrollable, canSubmit, title }) => {
    if (open) {
        document.body.classList.add('kmx-modal-scroll-lock');
    } else {
        document.body.classList.remove('kmx-modal-scroll-lock');
    }

    return (
        <div className={classnames([
            'kmx-modal',
            { 'kmx-modal--active': open },
            className
        ])}>
            <div className='kmx-modal__surface kmx-elevation-24'>
                {title ?
                    <div className='kmx-modal__header'>{title}</div>
                    : null}
                <div className={classnames([
                    'kmx-modal__body',
                    { 'kmx-modal__body--scrollable': scrollable }
                ])}>
                    {children}
                </div>
                {acceptText && onClose || cancelText && onClose ?
                    <div className='kmx-modal__footer'>
                        {cancelText ?
                            <button className='kmx-modal__action kmx-modal__action--cancel kmx-button kmx-button--tertiary' onClick={e => onClose(false)}>{cancelText}</button>
                            : null}
                        {acceptText ?
                            <button className='kmx-modal__action kmx-modal__action--accept kmx-button kmx-button--tertiary' disabled={canSubmit} onClick={e => onClose(true)}>{acceptText}</button>
                            : null}
                    </div>
                    : null}
            </div>
            <div onClick={e => onClose(false)} className='kmx-modal__background'></div>
        </div>
    );
}

export default Modal;